import { FaTimes } from 'react-icons/fa'
import styled from 'styled-components'

export const StyledFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledFilterRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  margin-bottom: ${({ theme }) => theme.spacing.sm}rem;

  &.packed {
    margin-bottom: 0rem;
    justify-content: flex-start;
  }
`

export const StyledFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const DeleteIcon = styled(FaTimes)<{ $isDisabled?: boolean }>`
  align-self: center;
  width: ${({ theme }) => theme.iconSize.xs}rem;
  height: ${({ theme }) => theme.iconSize.xs}rem;
  margin: ${({ theme }) => theme.spacing.sm}rem;
  cursor: pointer;

  &.isDisabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`
export const FilterHeader = styled.p`
  font-weight: 400;
  margin: 0;
`

export const StyledFormHeader = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.xs}rem;
`

export const FieldHelper = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.dashboard.textSubtle};
  text-wrap: pretty;
`

export const ConditionsBox = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.borderSoft};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
`

export const ConditionRow = styled.div<{ $divider?: boolean }>`
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr) 28px;
  grid-template-areas: 'label value remove';
  gap: ${({ theme }) => theme.spacing.sm}rem;
  align-items: center;
  padding: 0.45rem 0.45rem 0.45rem ${({ theme }) => theme.spacing.md}rem;
  border-top: ${({ $divider, theme }) =>
    $divider ? `1px solid ${theme.colors.neutralGray}` : 'none'};

  > *:nth-child(1) {
    grid-area: label;
  }

  > *:nth-child(2) {
    grid-area: value;
    min-width: 0;
  }

  > *:nth-child(3) {
    grid-area: remove;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    grid-template-columns: minmax(0, 1fr) 28px;
    grid-template-areas:
      'label remove'
      'value value';
    align-items: start;
  }
`

export const ConditionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;

  > svg {
    color: ${({ theme }) => theme.colors.iconGray};
    font-size: ${({ theme }) => theme.fontSize.xs}rem;
    width: 14px;
    flex-shrink: 0;
  }
`

export const ConditionLabelText = styled.span`
  min-width: 0;
  white-space: nowrap;

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    white-space: normal;
  }
`

export const AndMark = styled.span`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.px11}rem;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.iconGray};
  margin-right: 0.3rem;
`

export const ConditionTitle = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const TextWell = styled.div<{ $invalid?: boolean }>`
  background: ${({ theme }) => theme.colors.neutralGray};
  border-radius: 0.6rem;
  padding: 0.3rem ${({ theme }) => theme.spacing.sm}rem;
  border: 1px solid ${({ theme, $invalid }) => ($invalid ? theme.colors.error : 'transparent')};
`

export const WellInput = styled.input`
  background: transparent;
  border: 0;
  outline: none;
  padding: 0;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  color: ${({ theme }) => theme.colors.metalGray};
  min-height: 22px;
  width: 100%;
  font-family: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.colors.iconGray};
  }
`

export const AmountWells = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: ${({ theme }) => theme.spacing.xs}rem;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const AmountWell = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  min-width: 0;
  background: ${({ theme }) => theme.colors.neutralGray};
  border-radius: 0.6rem;
  padding: 0.3rem ${({ theme }) => theme.spacing.sm}rem;
`

export const AmountPrefix = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.dashboard.textSubtle};
  white-space: nowrap;
`

export const AmountValue = styled(WellInput)`
  text-align: right;
`

export const AmountSuffix = styled.span`
  color: ${({ theme }) => theme.dashboard.textSubtle};
  font-size: ${({ theme }) => theme.fontSize.px14}rem;
`

export const RangeDash = styled.span`
  color: ${({ theme }) => theme.colors.iconGray};

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    display: none;
  }
`

export const ConditionsHelp = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.dashboard.textSubtle};
  text-wrap: pretty;
`

export const HelpCode = styled.code`
  font-family: monospace;
  background: ${({ theme }) => theme.dashboard.surfaceSubtle};
  padding: 0 4px;
  border-radius: 4px;
`

export const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.iconGray};
  border-radius: 6px;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.px14}rem;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.neutralGray};
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`

export const ReadOnlyContactField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
`

export const ReadOnlyContactBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  background: ${({ theme }) => theme.dashboard.surfaceSubtle};
  border: 1px dashed ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  padding: ${({ theme }) => theme.spacing.xs}rem;
  cursor: not-allowed;
`

export const ReadOnlyContactLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.metalGray};
  line-height: ${({ theme }) => theme.fontSize.md}rem;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    color: ${({ theme }) => theme.colors.iconGray};
  }
`

export const ReadOnlyContactValue = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  min-height: 1.5em;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  color: ${({ theme }) => theme.colors.metalGray};

  svg {
    width: 0.8125rem;
    height: 0.8125rem;
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.iconGray};
  }
`

export const ReadOnlyContactHelper = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.dashboard.textSubtle};
  padding-left: ${({ theme }) => theme.spacing.xs}rem;
`

export const DisabledFieldset = styled.fieldset`
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;

  &:disabled {
    opacity: 1;
  }
`
